import React, { useContext } from "react";

import browserHead from "../../images/browser-header.png";
import mobileHead from "../../images/mobile-header.png";
import AppContext from "../../context";

function Header() {
  const { currentPage } = useContext(AppContext);

  const altText = `You have the power to shape students' math identities`;

  return (
    <>
      {currentPage === "pledges" && (
        <div className="landing-hdr">
          <picture>
            <source media="(min-width: 647px)" srcSet={browserHead} />
            <img src={mobileHead} alt={altText} />
          </picture>
        </div>
      )}
    </>
  );
}

export default Header;
